var _circle, _g, _circle2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeVisitaDomiciliar = function SvgIconeVisitaDomiciliar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#9DE695"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_31392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(-1 0 0 1 18 17)",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_31392)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8019 5.7011C15.0419 5.5001 15.3095 5.3999 15.6047 5.3999C15.8993 5.3999 16.1675 5.5001 16.4075 5.7011L21.4187 9.7445C21.5921 9.9545 21.6413 10.1819 21.5663 10.4261C21.4913 10.6709 21.3095 10.7933 21.0197 10.7933L20.4029 10.7999L20.4004 15.6083C20.4004 16.4081 20.0002 16.8059 19.2004 16.7999H18.0004L13.2004 16.8083H12.0004C11.2006 16.8083 10.8004 16.4081 10.8004 15.6083L10.8005 10.7999L10.2101 10.7933C9.93285 10.7921 9.74745 10.6703 9.65385 10.4261C9.56025 10.1825 9.61185 9.9563 9.80865 9.7469L14.8019 5.7011Z",
    fill: "#E1F6DF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_31392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8019 5.7011C15.0419 5.5001 15.3095 5.3999 15.6047 5.3999C15.8993 5.3999 16.1675 5.5001 16.4075 5.7011L21.4187 9.7445C21.5921 9.9545 21.6413 10.1819 21.5663 10.4261C21.4913 10.6709 21.3095 10.7933 21.0197 10.7933L20.4029 10.7999L19.2005 9.5999L15.6005 6.8513L12.0017 9.5999L10.8005 10.7999L10.2101 10.7933C9.93285 10.7921 9.74745 10.6703 9.65385 10.4261C9.56025 10.1825 9.61185 9.9563 9.80865 9.7469L14.8019 5.7011Z",
    fill: "#0E4700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4003 11.3999H13.8003V16.7999H17.4003V11.3999Z",
    fill: "#217B00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1627 20.4399C27.1627 20.4399 29.3365 20.0242 30.2968 20.7884C33.0906 23.0118 36.799 28.3019 39.0901 31.3749C39.7732 32.2911 40.4551 32.7349 40.7928 33.1867C41.3084 33.8765 41.4479 34.9464 40.821 35.2173C40.597 35.3141 40.0504 34.75 39.927 34.5295C39.8238 34.8268 39.6741 35.1302 39.4234 35.021C39.2729 34.9554 39.5447 34.8632 38.7359 33.7386C37.248 31.67 30.1271 25.3994 30.1271 25.3994L29.983 30.1017L24.0752 30.8716L22.7812 26.025C19.078 26.6495 15.0609 25.8407 12.9765 22.6665C12.0322 21.2284 11.5367 21.0564 11.3305 20.5629C10.8729 19.4679 11.1736 18.6334 11.5875 18.5425C11.9083 18.472 12.1902 19.1736 12.36 19.388C12.4875 19.2767 12.6129 18.7873 12.9689 18.9775C13.1798 19.0902 12.6554 19.1129 13.8302 21.2306C15.054 23.4365 18.9491 25.0321 22.4683 21.8086C23.2445 21.0977 24.4647 20.7915 24.4647 20.7915L27.1627 20.4399Z",
    fill: "#54C241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9883 31.5892C23.9883 31.5892 26.948 31.4955 29.9229 30.8158C30.6463 26.8857 28.8495 21.7471 26.9822 20.8817C26.9822 20.8817 26.3464 21.6082 25.6246 21.6913C24.926 21.7717 24.2584 21.3827 24.2584 21.3827C22.2317 23.2422 22.96 29.1819 23.9883 31.5892Z",
    fill: "#0E4700"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14652_31392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4322 21.9117C19.3144 23.0334 17.1959 24.1554 13.902 20.92L12.5002 22.1435C14.159 26.4068 18.138 26.9143 20.4789 27.213C21.4508 27.337 22.1404 27.4249 22.2642 27.7307C22.6759 28.7474 21.3202 43.8547 21.3202 43.8547L26.5302 43.1757L24.8823 21.8179L24.2777 20.8086C23.2658 20.9405 22.349 21.426 21.4322 21.9117ZM35.9604 41.7102L29.2445 42.5854C28.8257 40.2489 25.9927 21.6259 25.9927 21.6259L27.0688 20.4449C27.0688 20.4449 29.2415 19.9991 30.5211 20.7992C33.7145 22.7958 37.7424 27.7952 40.1446 32.071L38.1442 33.4198C37.033 32.5115 34.704 30.0127 33.1614 28.3576C32.2785 27.4103 31.6532 26.7394 31.6612 26.8013C32.1011 30.1768 34.0244 35.9223 35.4387 40.1473C35.6227 40.6969 35.798 41.2207 35.9604 41.7102Z",
    fill: "#E1F6DF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3023 18.4444C22.4921 19.1098 22.8429 19.5763 23.3421 19.879C23.753 20.1282 24.2206 20.0295 24.3565 20.2388C24.4924 20.4482 24.2638 20.7997 24.2638 20.7997C24.2638 20.7997 24.8969 21.4268 25.6877 21.3237C26.4785 21.2207 27.1319 20.4259 27.1319 20.4259C26.7043 19.8193 26.5275 18.4621 26.5275 18.4621C26.6162 18.319 26.6848 18.206 26.6848 18.206C26.6848 18.206 26.924 17.8002 26.9791 17.4173C27.0342 17.0343 26.9053 16.596 26.823 16.3683C26.7243 16.095 26.5585 15.8294 26.3479 15.6207C26.1345 15.4092 25.8785 15.2193 25.3992 15.0836C24.4468 14.8139 23.7761 15.1801 23.5502 15.3245C23.3244 15.4689 23.1134 15.6664 22.9225 15.9436C22.7316 16.2208 22.0262 17.4768 22.3023 18.4444Z",
    fill: "#54C241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.581 18.6824C26.581 18.6824 26.3216 18.441 25.9902 18.1226C26.2376 17.9879 26.4674 17.4281 26.0743 17.0251C25.6811 16.6222 25.1148 16.9231 24.9938 17.1281C24.7678 16.8876 24.6065 16.6956 24.5945 16.6261C24.5518 16.3781 25.2185 15.9052 25.1176 15.8146C25.0168 15.7241 24.5126 16.2138 24.3576 16.234C24.2025 16.2542 23.9507 15.9667 23.9507 15.9667C23.9507 15.9667 23.5175 16.5549 23.3178 16.5389C23.118 16.5229 23.2246 16.2416 23.2246 16.2416C23.2246 16.2416 22.7858 16.5997 22.492 16.6045C22.1983 16.6093 21.6643 16.4807 21.6366 16.2683C21.6089 16.0559 22.0749 15.9952 22.0749 15.9952C22.0749 15.9952 21.9659 15.6517 22.0797 15.4068C22.1934 15.1619 22.5269 15.0226 22.5269 15.0226C22.5269 15.0226 21.9918 14.7118 22.4378 14.5171C22.8838 14.3223 23.7576 14.4851 23.7576 14.4851C23.7576 14.4851 23.7134 14.1619 23.9379 14.0333C24.1624 13.9047 24.3784 14.2224 24.7351 14.2998C25.5239 14.057 26.5771 14.4947 26.5771 14.4947C26.5771 14.4947 26.7723 14.1081 27.0649 14.3225C27.3574 14.5368 27.1206 14.7499 27.1206 14.7499C27.1206 14.7499 27.2828 15.0325 27.3888 15.3027C27.4947 15.5729 27.4441 16.1829 27.4441 16.1829C27.4441 16.1829 27.8221 15.916 27.8763 16.3318C27.9304 16.7476 27.3674 17.1693 27.3674 17.1693C27.3674 17.1693 27.5891 17.0196 27.6371 17.2084C27.6852 17.3972 27.5078 17.7212 27.5078 17.7212C27.5078 17.7212 27.6998 18.1148 27.6704 18.3439C27.6409 18.5729 27.1631 18.41 27.1631 18.41C27.1631 18.41 27.2345 18.7002 26.9931 18.8116C26.7516 18.923 26.581 18.6824 26.581 18.6824Z",
    fill: "#2E8E16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31392",
    x: 0.222222,
    y: 0.111111,
    width: 35.5556,
    height: 35.5556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.556863 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31392",
    x: 8.90231,
    y: 4.69357,
    width: 13.4042,
    height: 12.8211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.353166
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.643137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_31392",
    x: 8.90231,
    y: 4.69357,
    width: 13.4042,
    height: 6.81266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.353166
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.643137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14652_31392",
    x: 11.6369,
    y: 19.4578,
    width: 29.371,
    height: 25.2602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.431647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.643137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31392",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeVisitaDomiciliar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-visita-domiciliar.a62cf1cb.svg";
export { ForwardRef as ReactComponent };